export default __webpack_public_path__ + "static/media/CPASAGE_Client home page icons-04.4f0480e5.svg";